module.exports = __webpack_public_path__ + "img/slide11.c78c67e1.png";